require("handlebars");
import Handlebars from "handlebars";
import axios from "axios";

export default class GalleryLoader {
  constructor() {
    if (!this.vars()) return false;
  }

  vars() {
    this.selectors = {
      loader: "gallery-page__loading",
      loaderHidden: "gallery-page__loading--hidden",
      handlebarsWrapper: "gallery-handlebars-wrapper",
      galleryItem: "gallery-item"
    };

    this.handlebarsWrapper = document.getElementById(
      this.selectors.handlebarsWrapper
    );

    this.loader = document.querySelector(`.${this.selectors.loader}`);

    if (!this.handlebarsWrapper || !this.loader) return false;

    this.pageId = this.handlebarsWrapper.getAttribute("data-page");
    this.pageUrl = this.handlebarsWrapper.getAttribute("data-page-url");

    if (!this.pageId || !this.pageUrl) return false;

    this.galleryItems = null;
    this.latestGalleryItem = null;

    this.getGalleryItems();

    this.mpSpSpTemplate = require("./templates/mp-sp-sp.handlebars");
    this.spSpSpTemplate = require("./templates/sp-sp-sp.handlebars");
    this.spSpMpTemplate = require("./templates/sp-sp-mp.handlebars");

    this.apiRoutes = {
      base: `${this.pageUrl}/wp-json/api/v1/`,
      gallery: "gallery"
    };

    this.api = axios.create({
      baseURL: this.apiRoutes.base
    });

    this.observerOptions = {
      rootMargin: "0px 0px -100px 0px"
    };

    this.getData();

    this.data = null;
    this.currentSection = 0;
    this.photos = document.querySelectorAll("a.lightbox-photo");
    this.lightbox = null;

    if (this.photos.length) {
      this.initLightbox();
    }

    return true;
  }

  initLightbox() {
    this.lightbox = $("a.lightbox-photo").simpleLightbox({
      widthRatio: 0.9,
      heightRatio: 0.825,
      navText: ["", ""],
      closeText: [""],
      showCounter: false,
      additionalHtml: [
        '<a class="lightbox-photo-destiny" href="" download></a>'
      ]
    });
    this.setupPhotosEvents();
  }

  resetLightbox() {
    this.lightbox.destroy();
    this.photos = document.querySelectorAll("a.lightbox-photo");
    this.initLightbox();
  }

  setupPhotosEvents() {
    $(this.photos).on("change.simplelightbox", e => {
      this.handlePhotoChange(e);
    });

    $(this.photos).on("shown.simplelightbox", e => {
      this.handlePhotoChange(e);
    });
  }

  handlePhotoChange(e) {
    const url = e.target.getAttribute("data-full");
    const download = document.querySelector(".lightbox-photo-destiny");
    download.setAttribute("href", url);
  }

  getData() {
    this.api.get(`${this.apiRoutes.gallery}/${this.pageId}`).then(response => {
      if (response.status === 200) {
        this.data = response.data;
        this.init();
      }
    });
  }

  getGalleryItems() {
    this.galleryItems = document.querySelectorAll(
      `.${this.selectors.galleryItem}`
    );
    this.latestGalleryItem = this.galleryItems[this.galleryItems.length - 1];
  }

  init() {
    this.initObservers();
    this.setObservers();
  }

  initObservers() {
    this.observer = new IntersectionObserver((entries, observer) => {
      this.observerCallback(entries, observer);
    }, this.observerOptions);
  }

  setObservers() {
    this.observer.observe(this.latestGalleryItem);
  }

  resetObservers() {
    this.observer.unobserve(this.latestGalleryItem);
    this.getGalleryItems();
    this.setObservers();
  }

  disableObservers() {
    this.observer.unobserve(this.latestGalleryItem);
  }

  observerCallback(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.handleIntersection();
      }
    });
  }

  showLoader() {
    this.loader.classList.remove(this.selectors.loaderHidden);
  }

  hideLoader() {
    this.loader.classList.add(this.selectors.loaderHidden);
  }

  handleIntersection() {
    this.disableObservers();
    this.showLoader();
    this.addToGallery();
    this.hideLoader();
    this.resetLightbox();
    this.currentSection++;

    if (this.data.length > this.currentSection) {
      this.resetObservers();
    } else {
      this.disableObservers();
    }
  }

  addToGallery() {
    const data = this.data[this.currentSection];
    switch (data["kind-of-section"]) {
      case "mp-sp-sp":
        this.handlebarsWrapper.innerHTML += this.setupMpSpSp(data);
        break;
      case "sp-sp-sp":
        this.handlebarsWrapper.innerHTML += this.setupSpSpSp(data);
        break;
      case "sp-sp-mp":
        this.handlebarsWrapper.innerHTML += this.setupSpSpMp(data);
        break;
    }
  }

  setupMpSpSp(data) {
    const smallRight = [];

    data["small-photos--right"].forEach(photo => {
      smallRight.push({
        large: photo["spr--photo"].sizes["thumbnail-gallery-large"],
        small: photo["spr--photo"].sizes["thumbnail-gallery-small"],
        alt: photo["spr--photo"].alt,
        title: photo["spr--title"],
        text: photo["spr--text"],
        url: photo["spr--photo"].url
      });
    });

    const mediumLeft = {
      large:
        data["medium-photos--left"]["mpl--photo"].sizes[
          "thumbnail-gallery-large"
        ],
      medium:
        data["medium-photos--left"]["mpl--photo"].sizes[
          "thumbnail-gallery-medium"
        ],
      alt: data["medium-photos--left"]["mpl--photo"].alt,
      title: data["medium-photos--left"]["mpl--title"],
      text: data["medium-photos--left"]["mpl--text"],
      url: data["medium-photos--left"]["mpl--photo"].url
    };

    return this.mpSpSpTemplate({
      smallRight,
      mediumLeft
    });
  }

  setupSpSpSp(data) {
    const photos = [];

    data["small-photos--one-row"].forEach(photo => {
      photos.push({
        large: photo["photo"].sizes["thumbnail-gallery-large"],
        small: photo["photo"].sizes["thumbnail-gallery-small"],
        alt: photo["photo"].alt,
        title: photo["title"],
        text: photo["text"],
        url: photo["photo"].url
      });
    });

    return this.spSpSpTemplate({
      photos
    });
  }

  setupSpSpMp(data) {
    const smallLeft = [];

    data["small-photos--left"].forEach(photo => {
      smallLeft.push({
        large: photo["spl--photo"].sizes["thumbnail-gallery-large"],
        small: photo["spl--photo"].sizes["thumbnail-gallery-small"],
        alt: photo["spl--photo"].alt,
        title: photo["spl--title"],
        text: photo["spl--text"],
        url: photo["spl--photo"].url
      });
    });

    const mediumRight = {
      large:
        data["medium-photos--right"]["mpr--photo"].sizes[
          "thumbnail-gallery-large"
        ],
      medium:
        data["medium-photos--right"]["mpr--photo"].sizes[
          "thumbnail-gallery-medium"
        ],
      alt: data["medium-photos--right"]["mpr--photo"].alt,
      title: data["medium-photos--right"]["mpr--title"],
      text: data["medium-photos--right"]["mpr--text"],
      url: data["medium-photos--right"]["mpr--photo"].url
    };

    return this.spSpMpTemplate({
      smallLeft,
      mediumRight
    });
  }
}
